// Get all trades
export const GET_MASTER_SUBSYSTEMS_REQUEST = "GET_MASTER_SUBSYSTEMS_REQUEST";
export const GET_MASTER_SUBSYSTEMS_SUCCESS = "GET_MASTER_SUBSYSTEMS_SUCCESS";
export const GET_MASTER_SUBSYSTEMS_FAILURE = "GET_MASTER_SUBSYSTEMS_FAILURE";

// Add trade
export const ADD_MASTER_SUBSYSTEM_REQUEST = "ADD_MASTER_SUBSYSTEM_REQUEST";
export const ADD_MASTER_SUBSYSTEM_SUCCESS = "ADD_MASTER_SUBSYSTEM_SUCCESS";
export const ADD_MASTER_SUBSYSTEM_FAILURE = "ADD_MASTER_SUBSYSTEM_FAILURE";

// Update trade
export const UPDATE_MASTER_SUBSYSTEM_REQUEST = "UPDATE_MASTER_SUBSYSTEM_REQUEST";
export const UPDATE_MASTER_SUBSYSTEM_SUCCESS = "UPDATE_MASTER_SUBSYSTEM_SUCCESS";
export const UPDATE_MASTER_SUBSYSTEM_FAILURE = "UPDATE_MASTER_SUBSYSTEM_FAILURE";

// Delete trade
export const DELETE_MASTER_SUBSYSTEM_REQUEST = "DELETE_MASTER_SUBSYSTEM_REQUEST";
export const DELETE_MASTER_SUBSYSTEM_SUCCESS = "DELETE_MASTER_SUBSYSTEM_SUCCESS";
export const DELETE_MASTER_SUBSYSTEM_FAILURE = "DELETE_MASTER_SUBSYSTEM_FAILURE";

// Get Trade by Id
export const GET_MASTER_SUBSYSTEM_BY_ID_REQUEST = "GET_MASTER_SUBSYSTEM_BY_ID_REQUEST";
export const GET_MASTER_SUBSYSTEM_BY_ID_SUCCESS = "GET_MASTER_SUBSYSTEM_BY_ID_SUCCESS";
export const GET_MASTER_SUBSYSTEM_BY_ID_FAILURE = "GET_MASTER_SUBSYSTEM_BY_ID_FAILURE";

// Update Trade Entity Param
export const UPDATE_MASTER_SUBSYSTEM_ENTITY_PARAMS_SUCCESS = "UPDATE_MASTER_SUBSYSTEM_ENTITY_PARAMS_SUCCESS";
export const UPDATE_MASTER_SUBSYSTEM_ENTITY_PARAMS_FAILURE = "UPDATE_MASTER_SUBSYSTEM_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_ALL_MASTER_SUBSYSTEM_LOG_REQUEST = "GET_ALL_MASTER_SUBSYSTEM_LOG_REQUEST";
export const GET_ALL_MASTER_SUBSYSTEM_LOG_SUCCESS = "GET_ALL_MASTER_SUBSYSTEM_LOG_SUCCESS";
export const GET_ALL_MASTER_SUBSYSTEM_LOG_FAILURE = "GET_ALL_MASTER_SUBSYSTEM_LOG_FAILURE";

export const RESTORE_MASTER_SUBSYSTEM_LOG_REQUEST = "RESTORE_MASTER_SUBSYSTEM_LOG_REQUEST";
export const RESTORE_MASTER_SUBSYSTEM_LOG_SUCCESS = "RESTORE_MASTER_SUBSYSTEM_LOG_SUCCESS";
export const RESTORE_MASTER_SUBSYSTEM_LOG_FAILURE = "RESTORE_MASTER_SUBSYSTEM_LOG_FAILURE";

export const DELETE_MASTER_SUBSYSTEM_LOG_REQUEST = "DELETE_MASTER_SUBSYSTEM_LOG_REQUEST";
export const DELETE_MASTER_SUBSYSTEM_LOG_SUCCESS = "DELETE_MASTER_SUBSYSTEM_LOG_SUCCESS";
export const DELETE_MASTER_SUBSYSTEM_LOG_FAILURE = "DELETE_MASTER_SUBSYSTEM_LOG_FAILURE";

export const GET_MASTER_SUBSYSTEM_EXPORT_REQUEST = "GET_MASTER_SUBSYSTEM_EXPORT_REQUEST";
export const GET_MASTER_SUBSYSTEM_EXPORT_SUCCESS = "GET_MASTER_SUBSYSTEM_EXPORT_SUCCESS";
export const GET_MASTER_SUBSYSTEM_EXPORT_FAILURE = "GET_MASTER_SUBSYSTEM_EXPORT_FAILURE";

export const GET_ALL_CLIENT_USERS_REQUEST = "GET_ALL_CLIENT_USERS_REQUEST";
export const GET_ALL_CLIENT_USERS_SUCCESS = "GET_ALL_CLIENT_USERS_SUCCESS";
export const GET_ALL_CLIENT_USERS_FAILURE = "GET_ALL_CLIENT_USERS_FAILURE";

// Get all consultancy users
export const GET_ALL_CONSULTANCY_USERS_REQUEST = "GET_ALL_CONSULTANCY_USERS_REQUEST";
export const GET_ALL_CONSULTANCY_USERS_SUCCESS = "GET_ALL_CONSULTANCY_USERS_SUCCESS";
export const GET_ALL_CONSULTANCY_USERS_FAILURE = "GET_ALL_CONSULTANCY_USERS_FAILURE";

export const GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST = "GET_ALL_CONSULTANCIES_DROPDOWN_REQUEST";
export const GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS = "GET_ALL_CONSULTANCIES_DROPDOWN_SUCCESS";
export const GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE = "GET_ALL_CONSULTANCIES_DROPDOWN_FAILURE";

// Get all Clients
export const GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST";
export const GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS";
export const GET_ALL_CLIENTS_FAILURE = "GET_ALL_CLIENTS_FAILURE";

export const GET_ALL_BUILDINGS_DROP_DOWN_REQUEST = "GET_ALL_BUILDINGS_DROP_DOWN_REQUEST";
export const GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS = "GET_ALL_BUILDINGS_DROP_DOWN_SUCCESS";
export const GET_ALL_BUILDINGS_DROP_DOWN_FAILURE = "GET_ALL_BUILDINGS_DROP_DOWN_FAILURE";

export const GET_TRADE_DROPDOWN_REQUEST = "GET_TRADE_DROPDOWN_REQUEST";
export const GET_TRADE_DROPDOWN_SUCCESS = "GET_TRADE_DROPDOWN_SUCCESS";
export const GET_TRADE_DROPDOWN_FAILURE = "GET_TRADE_DROPDOWN_FAILURE";

export const GET_SYSTEM_BY_TRADE_DROPDOWN_REQUEST = "GET_SYSTEM_BY_TRADE_DROPDOWN_REQUEST";
export const GET_SYSTEM_BY_TRADE_DROPDOWN_SUCCESS = "GET_SYSTEM_BY_TRADE_DROPDOWN_SUCCESS";
export const GET_SYSTEM_BY_TRADE_DROPDOWN_FAILURE = "GET_SYSTEM_BY_TRADE_DROPDOWN_FAILURE";
